export default "__VITE_ASSET__BmbOIFL7__"